import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const About = () => {
  const features = [
    "Rapid iteration and prototyping",
    "Practical execution focused",
    "Experienced aerospace engineering team",
    "End-to-end project support",
    "Custom solutions for unique challenges",
    "Quality-driven approach"
  ];

  return (
    <section id="about" className="py-24 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
                About Puro Engineering
              </h2>
              <p className="text-xl text-slate-600 mb-8 leading-relaxed">
                We provide comprehensive engineering support for unmanned aviation programs, specializing in rapid iteration and practical execution. Our team brings expertise across the full development lifecycle—from initial concept to flight test.
              </p>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                Whether you need design support, integration assistance, flight test planning, or custom wiring solutions, we deliver engineering services tailored to your program's unique requirements.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                    <span className="text-slate-700 font-medium">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;



